var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftLineGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4C36EB5A-AF6B-41C7-AC9D-F6C2CCF094BD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Putanja",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal---Login",
    transform: "translate(-227.000000, -673.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(9.750000, 90.656250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(152.750000, 582.343750)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-left-line",
    transform: "translate(84.500000, 20.000000) rotate(-180.000000) translate(-84.500000, -20.000000) translate(64.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#d5d5d5",
    fillRule: "nonzero",
    points: "13.0466667 18.3333333 33.3333333 18.3333333 33.3333333 21.6666667 13.0466667 21.6666667 21.9866667 30.6066667 19.63 32.9633333 6.66666667 20 19.63 7.03666667 21.9866667 9.39333333"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLineGrey);
export default __webpack_public_path__ + "static/media/arrow-left-line-grey.8165d736e10869751052b844858cdd17.svg";
export { ForwardRef as ReactComponent };